'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.images = undefined;

var _preact = require('preact');

var _bifrost = require('@ecs/bifrost');

var _bifrost2 = _interopRequireDefault(_bifrost);

var _store = require('./store');

var _store2 = _interopRequireDefault(_store);

var _actions = require('./actions');

var actions = _interopRequireWildcard(_actions);

var _root = require('./root');

var _root2 = _interopRequireDefault(_root);

var _constants = require('./constants');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var images = exports.images = _constants.PRODUCTS;

exports.default = function (props, element) {
  var storeActions = _store2.default.actions(actions);

  storeActions.init({
    product: props.product,
    profile: props.profile,
    loggedIn: props.loggedIn,
    brand: props.brand,
    login: props.login,
    logout: props.logout,
    signUp: props.signUp,
    config: props.config,
    environment: props.environment,
    menus: props.menus,
    metric: props.metric,
    notification: props.notification
  });

  _bifrost2.default.initialize({ environment: props.environment });

  (0, _preact.render)((0, _preact.h)(_root2.default, null), element);

  delete storeActions.analyticsEvent;

  return storeActions;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ecs/heimdall/build/index.js
// module id = 67
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38